// extracted by mini-css-extract-plugin
module.exports = {"Project":"Project_Project__3w1yQ","container":"Project_container__3GQlN","descContainer":"Project_descContainer__18-Kw"};